import React from "react";
import { Show, SimpleShowLayout, TextField, NumberField, DateField, useRecordContext } from "react-admin";
import ReactMarkdown from "react-markdown";
import { Box, Typography } from "@mui/material";

const NotesField = () => {
  const record = useRecordContext();
  if (!record) { return null; }
  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>Notas (PT)</Typography>
      <ReactMarkdown>{record.notesPt || "_Sem notas._"}</ReactMarkdown>
      {record.commitFrom && (
        <Typography variant="caption" color="text.secondary">
          Commits: {String(record.commitFrom).slice(0, 8)} → {String(record.commitTo || "").slice(0, 8)}
        </Typography>
      )}
    </Box>
  );
};

const AppReleasesShow = () => (
  <Show title="Versão do app">
    <SimpleShowLayout>
      <TextField source="version" label="Versão" />
      <NumberField source="build" label="Build" />
      <DateField source="releaseDate" label="Lançamento" />
      <NotesField />
    </SimpleShowLayout>
  </Show>
);

export default AppReleasesShow;
